// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__2ih-P","hero":"Landing_hero__XTl5n"};